
























import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "MaintenanceForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    correct : { type: Object, default() { return {} } },
  },
  data() {
    return {
      host       : "https://data.taisam.cn",
      maintenance: { fee: "" },
      change     : {} as any,
      rules      : { fee : { required: true, message: "请填写场馆软硬件运维费用：", trigger: "blur" } },
      show       : true,
    }
  },
  computed: {
    if_correct() {
      return ((): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.correct, "maintenance_payment")) {
          if (this.correct.id && this.correct.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      })
    }
  },
  methods: {
    init(data: any, change: any) {
      this.$nextTick(() => {
        // 处理运维费用
        this.maintenance.fee = data.maintenance_payment
        if (change && !change.maintenance_payment) this.show = false
        if (change && change.maintenance_payment) this.change.maintenance_payment = change.maintenance_payment
      })
    },
    show_correct(): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.correct, "maintenance_payment")) {
        if (this.correct.id && this.correct.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    submit() {
      const params = { estimate_id: this.id, maintenance_payment: this.maintenance.fee }
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        if (valid) {
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    maintenance: {
      handler() {
        this.$nextTick(() => {
          if (this.correct.id == undefined) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep   : true
    }
  }
})
